import { Box, Alert, CircularProgress, Container } from '@mui/material'
import * as React from 'react'
import { useParams } from 'react-router'

import TripCard from '../components/cards/TripCard'
import TripService from '../services/TripService'

export default function TripView() {
  const { id } = useParams()

  const [trip, setTrip] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    const fetchTrip = async () => {
      try {
        setLoading(true)
        const data = await TripService.getTrip(id)
        setTrip(data)
      } catch (err) {
        console.error('Failed to fetch trip details:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchTrip()
  }, [id])

  const handleChange = async () => {
    const updatedTrip = await TripService.getTrip(id)
    setTrip(updatedTrip)
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    )
  }

  if (!trip) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">Trip not found</Alert>
      </Box>
    )
  }

  return (
    <Container maxWidth="md">
      <TripCard trip={trip} mode="detailed" updateHook={handleChange} deleteHook={handleChange} />
    </Container>
  )
}
